<template>
  <div class="row">
    <div class="col-sm-12">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>Datum</th>
            <th>Lager</th>
            <th v-if="showSupplier">Lieferant</th>
            <th>Summe</th>
            <th class="text-center">Produkte</th>
            <th class="text-center">Status</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody v-if="orders.length">
          <tr is="OrderRow" v-for="order in orders" :key="order.id"
            :order="order"
            :show-supplier="showSupplier"
            @editOrder="editOrder"
            @deleteOrder="deleteOrder"
            @changeStatus="changeStatus"
            @openProducts="openProducts"
            @createStockRotationsFromOrder="createStockRotationsFromOrder"
            @openSendOrderDialog="openSendOrderDialog"
          />
        </tbody>
      </table>
    </div>
    <order-products-dialog
      :show="showProducts"
      :order-products="orderProducts"
      @close="showProducts = false"
    />
    <send-order-dialog
      v-if="order"
      :show="showSendOrderDialog"
      @close="closeSendOrderDialog"
      :contact-people="contactPeople"
      :order="order"
      @orderSent="orderSent"
    />
    <create-stock-rotations-dialog
      v-if="createForOrder"
      :show="showCreateStockRotationsDialog"
      :order="createForOrder"
      @updateData="updateData"
      @close="closeCreateDialog"
      @stockRotationsCreated="stockRotationsCreated"
    />
  </div>
</template>

<script>
import OrderRow from './order-row'
import OrderProductsDialog from './order-products-dialog'
import SendOrderDialog from './send-order-dialog'
import formatEmailText from './format-email-text'
import CreateStockRotationsDialog from './create-stock-rotations-dialog'

export default {
  props: {
    orders: null,
    showSupplier: {
      default: true
    }
  },
  components: {
    OrderRow,
    OrderProductsDialog,
    SendOrderDialog,
    CreateStockRotationsDialog
  },
  data () {
    return {
      orderProducts: [],
      showProducts: false,
      showSendOrderDialog: false,
      showCreateStockRotationsDialog: false,
      contactPeople: [],
      order: null,
      createForOrder: null
    }
  },
  methods: {
    updateData(){
      this.$emit('updateOrders')
    },
    async changeStatus (order) {
      await this.initCsrf()

      this.$http.put(`/orders/${order.id}`, {
        supplier_id: order.supplier_id,
        warehouse_id: order.warehouse_id,
        status: order.status,
        append_prices: order.append_prices,
        date: order.date  ?  order.date : order.created_at
      }).then(({ data }) => {
        this.$notify({
          message: 'Status erfolgreich geändert.',
          type: 'success'
        })
      })
    },
    editOrder (order) {
      this.$router.push(`/orders/${order.id}/edit`)
    },
    async deleteOrder (order) {
      if (confirm(`Bestellung wirklich löschen?`)) {
        await this.initCsrf()

        this.$http.delete(`/orders/${order.id}`).then(({ data }) => {
          this.$notify({
            message: `Bestellung erfolgreich gelöscht.`,
            type: 'success'
          })
          const index = this.orders.findIndex(({ id }) => data.id === id)
          this.orders.splice(index, 1)
        })
      }
    },
    openProducts (order) {
      this.orderProducts = order.products
      this.showProducts = true
      // this.$http.get(`/orders/${order.id}/products`).then(({ data }) => {
      //   this.orderProducts = data
      //   this.showProducts = true
      // })
    },
    createStockRotationsFromOrder (order) {
      this.createForOrder = order
      this.showCreateStockRotationsDialog = true
    },
    closeCreateDialog () {
      this.createForOrder = null
      this.showCreateStockRotationsDialog = false
    },
    stockRotationsCreated (data) {
      this.createForOrder.status = data.status
      this.createForOrder.products_registered_at = data.products_registered_at
      this.closeCreateDialog()
    },
    openSendOrderDialog (order) {
      const productsMapped = order.products.map(product => {
        const pzn = product.pzn ? `${product.pzn} | ` : ''
        const referenznummer = product.pivot.referenznummer ? `${product.pivot.referenznummer} | ` : ''
        let bla = `${product.pivot.quantity} x ${pzn}${referenznummer}${product.name}`
        if (order.append_prices) {
          bla += ` (à ${this.$options.filters.priceFromCentEuro(product.pivot.price)})`
        }
        return bla
      })
      order.email_text = formatEmailText(productsMapped, order.email_text)
      this.order = order
      this.$http.get(`/suppliers/${order.supplier_id}/contact_people`).then(({ data }) => {
        this.contactPeople = data
        this.showSendOrderDialog = true
      })
    },
    closeSendOrderDialog () {
      this.showSendOrderDialog = false
      this.order = null
    },
    orderSent (order) {
      this.order.status = 'ordered'
      this.closeSendOrderDialog()
    }
  }
}
</script>

<style>
</style>
